export default __webpack_public_path__ + "static/media/linkedin-icon.143a3c2c.svg";